import { isOfflineWriteBlockedError } from "common/utils/offlineWriteGuard";
import { isOfflineMutationBlockedError } from "model/useGuardedMutation";

/**
 * Global unhandledrejection handler. Offline guarded mutations reject with
 * OfflineMutationBlockedError after showing a toast; raw fetch writes rejected
 * by offlineWriteGuard reject with a TypeError. Suppress both expected paths so
 * they are not logged as app errors.
 */
export function handleUnhandledRejection(event: PromiseRejectionEvent): void {
  if (
    isOfflineMutationBlockedError(event.reason) ||
    isOfflineWriteBlockedError(event.reason)
  ) {
    event.preventDefault();
    return;
  }

  console.error(
    "Unhandled rejection (promise: ",
    event.promise,
    ", reason: ",
    event.reason,
    ")."
  );
}

export function installUnhandledRejectionHandler(): void {
  window.addEventListener("unhandledrejection", handleUnhandledRejection);
}
